"use client";

import React from "react";
import { CheckCircle2 } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Hero() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section className="relative min-h-screen flex flex-col bg-background overflow-hidden">
      <div className="flex-1 grid grid-cols-1 lg:grid-cols-2 w-full max-w-7xl mx-auto">

        {/* LEFT SIDE */}
        <div ref={textRef} className={`flex flex-col justify-center px-4 py-10 md:px-6 md:py-16 lg:py-24 transition-all duration-1000 ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-12"}`}>
          <div className="max-w-xl space-y-8">

            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent text-[#D4AF37] text-xs font-bold uppercase">
              <CheckCircle2 className="size-3" />
              Elite Clinical Network
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-bold text-[#0A1A2F] leading-[1.05]">
              Staffing Support for Healthcare Facilities
            </h1>

            <p className="text-base md:text-xl text-muted-foreground">
              Atlas Surgical Partners helps healthcare facilities secure qualified surgical and perioperative professionals quickly and efficiently.
            </p>

            <div className="flex flex-col gap-4 pt-4">

              <div className="text-center text-[14px] font-bold uppercase text-[hsl(47,65%,48%)]">
                Facilities
              </div>

              <Button size="lg" className="bg-[#1E4FA3] text-white h-14" asChild>
                <Link to="/facilities/">Request Coverage</Link>
              </Button>

              <div className="text-center text-[14px] font-bold uppercase text-[hsl(47,65%,48%)]">
                Clinicians
              </div>

              <Button size="lg" className="bg-[#1E4FA3] text-white h-14" asChild>
                <Link to="/clinicians/">Join Our Network</Link>
              </Button>

            </div>
          </div>
        </div>

        {/* RIGHT SIDE IMAGE */}
        <div ref={imageRef} className={`flex items-center justify-center p-4 transition-all duration-1000 delay-300 ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <img src="https://atlassurgicalstaffing.com/wp-content/uploads/2026/04/ChatGPT-Image-Apr-1-2026-08_52_51-PM.png" alt="Healthcare staffing" className="w-full h-auto max-h-[700px] object-contain rounded-2xl shadow-2xl" />
        </div>

      </div>
    </section>;
}